import { DocumentsManagerHistory } from "us.collection.input-output/constants/Actions";
import { initialState } from "./State";
import _ from "lodash";

const {
  GET_ASSIGNED_DOCUMENTS_HISTORY,
  GET_ASSIGNED_DOCUMENTS_HISTORY_SUCCESS,
  GET_ASSIGNED_DOCUMENTS_HISTORY_FAIL,
  DELETE_ASSIGNED_DOCUMENTS_SUCCESS,
  DELETE_ASSIGNED_DOCUMENTS_FAIL,
  GET_ASSIGNED_DOCUMENT_CONTENT,
  GET_ASSIGNED_DOCUMENT_CONTENT_SUCCESS,
  GET_ASSIGNED_DOCUMENT_CONTENT_FAIL,
} = DocumentsManagerHistory;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_ASSIGNED_DOCUMENTS_HISTORY:
      return {
        ...state,
        assignedDocumentsList: {
          ...state.assignedDocumentsList,
          isLoading: true,
        },
      };
    case GET_ASSIGNED_DOCUMENTS_HISTORY_SUCCESS:
      return {
        ...state,
        assignedDocumentsList: {
          data: [
            ...(state.assignedDocumentsList?.data ?? []),
            ...(payload?.data ?? []),
          ],
          isLoading: false,
        },
      };

    case GET_ASSIGNED_DOCUMENTS_HISTORY_FAIL:
      return {
        ...state,
        assignedDocumentsList: {
          data: [],
          isLoading: false,
        },
      };
    case DELETE_ASSIGNED_DOCUMENTS_SUCCESS:
      _.remove((state.assignedDocumentsList as any).data, (doc: any) =>
        payload?.data?.documentIds.includes(doc.documentId),
      );
      return Object.assign({}, state, {
        assignedDocumentsList: {
          data: [...(state.assignedDocumentsList as any).data],
          isLoading: false,
        },
      });

    case DELETE_ASSIGNED_DOCUMENTS_FAIL:
      return {
        ...state,
        assignedDocumentsList: {
          ...state.assignedDocumentsList,
          isLoading: false,
        },
      };
    case GET_ASSIGNED_DOCUMENT_CONTENT:
      return Object.assign({}, state, {
        assignedDocumentContent: {
          data: "",
          isFetching: true,
        },
      });
    case GET_ASSIGNED_DOCUMENT_CONTENT_SUCCESS:
      return Object.assign({}, state, {
        assignedDocumentContent: {
          data: payload?.data[0] ?? "",
          isFetching: false,
        },
      });
    case GET_ASSIGNED_DOCUMENT_CONTENT_FAIL:
      return Object.assign({}, state, {
        assignedDocumentContent: {
          data: "",
          isFetching: false,
        },
      });
    default:
      return state;
  }
};
